// Modules
import * as Yup from 'yup'

// Application
import { maxBirthDateValidator } from 'utils'

export const LoginCPFSchema = Yup.object().shape({
    cpf: Yup.string().required('Campo obrigatório'),
    password: Yup.string().required('Campo obrigatório'),
})

export const LoginCIPSchema = Yup.object().shape({
    cpf: Yup.string().required('Campo obrigatório'),
    password: Yup.string().required('Campo obrigatório'),
    birthdate: Yup.string()
        .required('Campo obrigatório')
        .min(10, 'Preencha uma data de nascimento completa. Ex.: 10/05/1989.')
        .max(10, 'Preencha uma data de nascimento completa. Ex.: 10/05/1989.')
        .test('birthDate', 'Data de nascimento inválida', (value: string | undefined): boolean => maxBirthDateValidator(value)),
})
